import React, { Component } from 'react';
import PropTypes from 'prop-types';
import lottie from 'lottie-web';
import styled, { keyframes } from 'styled-components';
import $ from 'jquery';

import utils from '../../lib/utils';
import request from '../../lib/request';

import { getUserInfo, mergePromise, getMedalInfo } from '../../server/commonFun'
import { reqAPI } from '../../server/reqAPI';
import IndexCard from '../../components/index/index-card';
import UserCell from '../../components/index/user-cell';

import '../../static/css/index.scss';
import '../../static/css/common.scss';

lottie.setQuality('low');
let trailTimer;
let iconList = [];   // 顶部icon
let iconLoopTimer;
let clickTestAreaCount; // 测试区域——点击测试区域次数
let clickTestAreaBeforeTime = new Date().getTime(); // 测试区域——上一次的时间
let clickTestAreaNowTime = new Date().getTime(); // 测试区域——当前这次的时间

class Index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDeviceTest: window.localStorage.getItem('isTest'),
            showTestAreaInput: false,  // 测试区域——是否显示测试区域的输入框
            testAreaInputNumber: window.localStorage.getItem('testAreaInputNumber') ?
                parseInt(window.localStorage.getItem('testAreaInputNumber'), 10) + 1 : 0, // 测试区域——输入的页码数
        };
        this.noCamera = parseInt(utils.getQueryString('code'), 10) === 2 ? true : false;   // 为了配合第三方在电视设备上演示，没有摄像头
        this.hashChangeHandler = this.hashChangeHandler.bind(this);
    }

    componentDidMount() {
        const that = this;

        if (!this.context.user || !this.context.user.token) {
            this.context.getUser(() => {
                that.getUserInfo();
                that.getMedalInfo();
            });
        } else {
            that.getUserInfo();
            that.getMedalInfo();
        }

        if (that.noCamera) {
            window.localStorage.setItem("code", 2);
        }

        let index_water = document.getElementById('lottie_water');
        let index_land = document.getElementById('lottie_land');
        let index_stone = document.getElementById('lottie_stone');
        let index_play = document.getElementById('lottie_play');

        if (index_water) {
            lottie.loadAnimation({
                container: index_water, //包含动画的DOM元素
                renderer: 'svg',
                loop: true,
                autoplay: true,
                path: window.publicUrl + 'static/lottie/index_water.json', //动画的路径
            });
        }
        if (index_land) {
            lottie.loadAnimation({
                container: index_land, //包含动画的DOM元素
                renderer: 'svg',
                loop: true,
                autoplay: true,
                path: window.publicUrl + 'static/lottie/index_land.json', //动画的路径
            });
        }
        if (index_stone) {
            lottie.loadAnimation({
                container: index_stone, //包含动画的DOM元素
                renderer: 'svg',
                loop: true,
                autoplay: true,
                path: window.publicUrl + 'static/lottie/index_stone.json', //动画的路径
            });
        }
        if (index_play) {
            lottie.loadAnimation({
                container: index_play, //包含动画的DOM元素
                renderer: 'svg',
                loop: true,
                autoplay: true,
                path: window.publicUrl + 'static/lottie/index_play.json', //动画的路径
            });
        }

        this.addHashChangeHandler();

        // 隔一秒开始播放 icon 动效
        iconLoopTimer = setTimeout(() => {
            this.getAllHeaderIcon();
            that.headerIconLoop();
        }, 2000);
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
        clearInterval(trailTimer);
        clearTimeout(iconLoopTimer);
        window.removeEventListener('hashchange', this.hashChangeHandler);
        window.removeEventListener('DOMMouseScroll', this.onSrollHandler);
        window.removeEventListener('mousewheel', this.onSrollHandler);
    }

    // 添加 hash 改变的事件
    addHashChangeHandler() {
        window.addEventListener('hashchange', this.hashChangeHandler, false);
    }

    hashChangeHandler() {
        this.setState({
            showDeviceTest: window.localStorage.getItem('isTest'),
        });
    }

    // 获取用户信息
    getUserInfo() {
        const that = this;

        getUserInfo(this.context.user)
            .then(res => {
                that.setState({ userInfo: res });

                that.getItemsInfo();
            });
    }

    // 获取用户勋章信息
    getMedalInfo() {
        const that = this;

        getMedalInfo(this.context.user)
            .then(res => {
                that.setState({
                    medalInfo: res.data ? res.data : null
                });
            });
    }

    // 获取信息
    getItemsInfo() {
        request(`${reqAPI.index_card}`, this.context.user, { method: 'GET' })
            .then(res => res.json())
            .then(res => {
                if (res.code === 200) {
                    this.setState({
                        itemsCard: res.data ? res.data : null
                    });
                }
            });
    }

    // 点击顶部的跳转
    clickLinkHandler(type, way) {
        let linkUrl;

        switch (type) {
            case 'bind-wx':
                linkUrl = `#/bind-weixin`;
                break;
            case 'device-test':
                linkUrl = `#/device`;
                break;
            case 'plan':
                linkUrl = `#/device`;
                break;
            default: linkUrl = type;
        }

        if (way && way === 'openNew') {
            window.open(linkUrl);
        } else {
            window.location.href = linkUrl;
        }
    }

    // 获取所有的顶部的 icon
    getAllHeaderIcon() {
        const iconObject = document.querySelectorAll('.header-icon');

        if (iconObject) {
            for (let key in iconObject) {
                if (iconObject[key] && iconObject[key].id) {
                    iconList.push(iconObject[key].id)
                }
            }
        }
    }

    // 控制顶部的 icon 动效轮播
    headerIconLoop() {
        const that = this;
        const promiseList = [];
        let animateElement;
        let normalElement;

        for (let i = 0; i < iconList.length; i++) {
            animateElement = $('#' + iconList[i] + '-ani');
            normalElement = $('#' + iconList[i]);

            (function (animateElement, normalElement) {
                promiseList.push(() => that.generateIconPromise(animateElement, normalElement))
            })(animateElement, normalElement);
        }

        mergePromise(promiseList).then((data) => {
            iconLoopTimer = setTimeout(() => {
                that.headerIconLoop();
            }, 8000);
        });
    }

    // 生成每一个动画的 promise
    generateIconPromise(animateElement, normalElement) {
        return new Promise((resolve, reject) => {
            if (animateElement && normalElement) {
                let backgroundValue = normalElement.css('background');

                animateElement.css({
                    display: 'block'
                });
                normalElement.css({
                    background: 'none'
                });

                iconLoopTimer = setTimeout(() => {
                    animateElement.css({
                        display: 'none'
                    });
                    normalElement.css({
                        background: backgroundValue
                    });
                    resolve();
                }, 2000)
            }
        });
    }

    // 测试区域，连续点击6次，出输入页码的输入框
    clickTestAreaButton() {
        clickTestAreaNowTime = new Date().getTime();

        if (clickTestAreaNowTime - clickTestAreaBeforeTime < 300 || clickTestAreaCount === 0) {
            clickTestAreaCount += 1;
            clickTestAreaBeforeTime = clickTestAreaNowTime;
        } else {
            clickTestAreaCount = 0;
        }

        if (clickTestAreaCount > 5) {
            this.setState({
                showTestAreaInput: true
            });
        }
    }

    // 测试区域，输入页码改变事件
    testAreaInputChangeHandler(e) {
        if (e && e.target) {
            this.setState({
                testAreaInputNumber: e.target.value
            }, () => {
                window.localStorage.setItem('testAreaInputNumber',
                    this.state.testAreaInputNumber > 0 ? this.state.testAreaInputNumber - 1 : this.state.testAreaInputNumber);
            });
        }
    }

    render() {
        const that = this;
        const {
            itemsCard,
            showDeviceTest,
            userInfo,
            medalInfo,
            showTestAreaInput,
            testAreaInputNumber
        } = this.state;

        return (
            <IndexBox page='index' showInfo={true} showFM={false}>
                {userInfo && medalInfo && <UserCell data={Object.assign({}, { ...userInfo }, { ...medalInfo })} />}
                <HeaderButton>
                    <div onClick={() => { window.location = `#/setting`; }} >
                        <span className='header-setting' />
                        设置
                    </div>
                </HeaderButton>
                <HeaderButtonBox type='left'>
                    {
                        userInfo && !userInfo.hasWX &&
                        // id 名 和 image 会作为图片的名字，后面添加的时候 图片名与 id 名需要保持一致。直接改背景做动画的话会抖一下，因此改成了这种动画的占位（包含原图与动画）
                        <HeaderButtonItem
                            className='header-icon'
                            id='icon-bind-wx'
                            shake={true}
                            image='icon-bind-wx.png'
                            onClick={() => { this.clickLinkHandler('bind-wx') }}
                        >
                            <HeaderButtonItem
                                id='icon-bind-wx-ani'
                                shake={true}
                                animate={true}
                                image='icon-bind-wx-ani.png'
                                onClick={() => { this.clickLinkHandler('bind-wx') }}
                            />
                        </HeaderButtonItem>}
                    {
                        userInfo && userInfo.showLeaderBoard &&
                        <HeaderButtonItem
                            className='header-icon'
                            id='icon-plan'
                            image='icon-plan.png'
                            scale={1.2}
                            onClick={() => { this.clickLinkHandler(userInfo.leaderBoardPageURL ? userInfo.leaderBoardPageURL : '') }}
                        >
                            <HeaderButtonItem
                                id='icon-plan-ani'
                                image='icon-plan-ani.png'
                                animate={true}
                                scale={1.2}
                                onClick={() => { this.clickLinkHandler(userInfo.leaderBoardPageURL ? userInfo.leaderBoardPageURL : '') }}
                            />
                        </HeaderButtonItem>}
                </HeaderButtonBox>
                <HeaderButtonBox type='right' >
                    {
                        userInfo && userInfo.discountOrderUrl &&
                        <HeaderButtonItem
                            className='header-icon'
                            shake={true}
                            id='icon-order'
                            image='icon-order.png'
                            onClick={() => { this.clickLinkHandler(userInfo.discountOrderUrl + '&from_buy=pc', 'openNew') }}
                        >
                            <HeaderButtonItem
                                shake={true}
                                animate={true}
                                id='icon-order-ani'
                                image='icon-order-ani.png'
                                onClick={() => { this.clickLinkHandler(userInfo.discountOrderUrl + '&from_buy=pc', 'openNew') }}
                            />
                        </HeaderButtonItem>}
                    {!showDeviceTest &&
                        <HeaderButtonItem
                            className='header-icon'
                            id='icon-device-test'
                            image='icon-device-test.png'
                            onClick={() => { this.clickLinkHandler('device-test') }}
                        >
                            <HeaderButtonItem
                                animate={true}
                                id='icon-device-test-ani'
                                image='icon-device-test-ani.png'
                                onClick={() => { this.clickLinkHandler('device-test') }}
                            />
                        </HeaderButtonItem>}
                    {that.noCamera ?
                        <div style={{ "position": "fixed", "top": "100px", "right": "60px" }}>教学演示版</div>
                        : null
                    }
                    <TestAreaButton onClick={() => this.clickTestAreaButton()}>
                        {showTestAreaInput && <input type='number' value={testAreaInputNumber} onChange={e => { this.testAreaInputChangeHandler(e) }} />}
                    </TestAreaButton>
                </HeaderButtonBox>
                <LottieCloud>
                    <div>
                        <img alt='' src={require('../../static/img/clouds_left.png')} />
                    </div>
                    <div>
                        <img alt='' src={require('../../static/img/clouds_right.png')} />
                    </div>
                </LottieCloud>
                <LottieLand id='lottie_land' />
                <LottieStone id='lottie_stone' />
                <LottiePlay
                    id='lottie_play'
                    onClick={() => {
                        window.location = `#/path`;
                    }}
                />
                <Background className='lesson_wrap'>
                    <LottieWater id='lottie_water' />
                    <IndexCard data={itemsCard} />
                </Background>

                <div className='bottom-button-container'>
                    <div className='bottom-button-box'>
                        <div
                            className='main-course'
                            onClick={() => {
                                window.location.href = `#/path`;
                            }}
                        />
                        <div>主修内容</div>
                    </div>
                    <div className='bottom-button-box'>
                        <div
                            className='special-course'
                            onClick={() => {
                                window.location.href = `#/path?special=2004`;
                            }}
                        />
                        <div>KET</div>
                    </div>
                    <div className='bottom-button-box'>
                        <div
                            className='subject-course'
                            onClick={() => {
                                window.location.href = `#/subject`;
                            }}
                        />
                        <div>主题学习</div>
                    </div>
                    {userInfo && userInfo.showReadingLesson &&
                        <div
                            className='bottom-button-box'
                            onClick={() => {
                                window.location.href = `https://www.putaoabc.com/onlinepages/picbook/readers?v=${window.pt_vid}`;
                            }}
                        >
                            <div className='readering-course' />
                            <div>阅读思维</div>
                        </div>
                    }
                    <div
                        className='bottom-button-box'
                        onClick={() => {
                            window.location.href = `https://www.putaoabc.com/onlinepages/library/homepage?v=${window.pt_vid}`;
                        }}
                    >
                        <div className='reader-course' />
                        <div>绘本馆</div>
                    </div>
                    <div className='bottom-button-box'>
                        <div
                            className='FM-course'
                            onClick={() => {
                                window.location.href = `#/FM?level=1`;
                            }}
                        />
                        <div>儿歌馆</div>
                    </div>
                    <div className='bottom-button-box'>
                        <div
                            className='wordcard-course'
                            onClick={() => {
                                window.location.href = `https://www.putaoabc.com/onlinepages/course_assist/wordcard/?v=${Math.random()}`;
                            }}
                        />
                        <div>单词馆</div>
                    </div>
                </div>
            </IndexBox>
        );
    }
}

export default Index;

Index.contextTypes = {
    user: PropTypes.object,
    getUser: PropTypes.func,
}

const IndexBox = styled.div`
    width: 100%;
    height: 100%;
`;

const LottieCloud = styled.div`
    width: 100%;
    height: 32%;
    background: linear-gradient(to bottom, #6bb3ff, #d8c4cb 25%, #fff3d0 60%, #ffd6c2);
    position: relative;

    >div:nth-child(1) {
        width: 19.53%;
        position: absolute;
        left: 0;
        bottom: 0;
        img {
            width: 100%;
            vertical-align: middle;
        }
    }

    >div:nth-child(2) {
        width: 21.146%;
        position: absolute;
        right: 0;
        bottom: 0;
        img {
            width: 100%;
            vertical-align: middle;
        }
    }
`;

const LottieWater = styled.div`
    position: absolute;
    min-height: 4rem;
    height: 4.5rem;
`;

const Background = styled.div`
    width: 100%;
    height: 100%;
    background: linear-gradient(to bottom, #ffbeb9 0%, #a0b4ff 10%, #78aaff 55%, #1e87d7);
    padding-top: 100px;
    overflow: auto;
`;

const LottieLand = styled.div`
    width: 100%;
    height: 49%;
    position: absolute;
    top: 0;
    animation: opacity-in 1s;
`;

const LottieStone = styled.div`
    width: 80%;
    height: 30%;
    position: absolute;
    top: 24%;
    left: 10%;
`;

const LottiePlay = styled.div`
    width: 40%;
    height: 32%;
    position: absolute;
    top: 9%;
    left: 30%;
    cursor: pointer;
`;

const HeaderButtonBox = styled.div`
    position: fixed;
    height: 0.66rem;
    top: 0.54rem;
    z-index: 999;

    ${props => props.type && props.type === 'right' ? 'right: 2.5rem' : 'left: 5.3rem'}
`;

const HeaderButtonItem = styled.span`
    display: inline-block;
    position: relative;
    top: 0;
    width: 0.66rem;
    height: 0.66rem;
    background: url(${props => props.image ? require(`../../static/img/index/${props.image}`) : ''}) no-repeat center;
    background-size: contain;
    cursor: pointer;

    ${props => props.animate ? 'display: none' : 'margin: 0 0.13rem'}

    ${props => props.scale ? `
        transform: scale(${props.scale});
        -webkit-transform: scale(${props.scale});
    ` : ''}

    ${props => props.scale && props.animate ? `
        transform: scale(1);
        -webkit-transform: scale(1);
    ` : ''}

    ${props => props.shake ? `
        &::after {
            position: absolute;
            content: '';
            display: block;
            top: 0.06rem;
            right: 0;
            width: 0.13rem;
            height: 0.13rem;
            background: #FF4625;
            border-radius: 50%;
        }
    ` : ''}
`;

const HeaderButton = styled.div`
    position: fixed;
    top: 0.54rem;
    right: 0.76rem;
    width: 1.6rem;
    height: 0.6rem;
    padding-left: 0.82rem;
    border-radius: 0.3rem;
    font-size: 0.32rem;
    color: #fff;
    line-height: 0.6rem;
    background: rgba(125, 45, 255, 0.3);
    cursor: pointer;
    z-index: 10;

    .header-reward,
    .header-setting {
        position: absolute;
        left: 0.18rem;
        top: 0.08rem;
        height: 0.42rem;
    }

    .header-reward {
        width: 21px;
        background: url('../img/index/reward.png') no-repeat center;
        background-size: contain;
    }

    .header-setting {
        width: 0.46rem;
        background: url(${require('../../static/img/index/setting-white.png')}) no-repeat center;
        background-size: contain;
    }
`;

const TestAreaButton = styled.div`
    position: fixed;
    top: 1.2rem;
    right: 0;
    width: 3rem;
    height: 0.75rem;

    >input {
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 0.01rem;
        border: none;
        top: 100%;
        outline-style: none;
        font-size: 0.3rem;
    }
`;


// WEBPACK FOOTER //
// ./src/route/version-2/Index.js